/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardResponseObject } from './RewardResponseObject';
import {
    RewardResponseObjectFromJSON,
    RewardResponseObjectFromJSONTyped,
    RewardResponseObjectToJSON,
    RewardResponseObjectToJSONTyped,
} from './RewardResponseObject';

/**
 * 
 * @export
 * @interface ClaimCheckpointRewardResponse
 */
export interface ClaimCheckpointRewardResponse {
    /**
     * 
     * @type {Array<RewardResponseObject>}
     * @memberof ClaimCheckpointRewardResponse
     */
    rewards: Array<RewardResponseObject>;
    /**
     * Name of the claimed checkpoint
     * @type {string}
     * @memberof ClaimCheckpointRewardResponse
     */
    checkpointName: string;
}

/**
 * Check if a given object implements the ClaimCheckpointRewardResponse interface.
 */
export function instanceOfClaimCheckpointRewardResponse(value: object): value is ClaimCheckpointRewardResponse {
    if (!('rewards' in value) || value['rewards'] === undefined) return false;
    if (!('checkpointName' in value) || value['checkpointName'] === undefined) return false;
    return true;
}

export function ClaimCheckpointRewardResponseFromJSON(json: any): ClaimCheckpointRewardResponse {
    return ClaimCheckpointRewardResponseFromJSONTyped(json, false);
}

export function ClaimCheckpointRewardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimCheckpointRewardResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'rewards': ((json['rewards'] as Array<any>).map(RewardResponseObjectFromJSON)),
        'checkpointName': json['checkpointName'],
    };
}

export function ClaimCheckpointRewardResponseToJSON(json: any): ClaimCheckpointRewardResponse {
    return ClaimCheckpointRewardResponseToJSONTyped(json, false);
}

export function ClaimCheckpointRewardResponseToJSONTyped(value?: ClaimCheckpointRewardResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rewards': ((value['rewards'] as Array<any>).map(RewardResponseObjectToJSON)),
        'checkpointName': value['checkpointName'],
    };
}

